/** billing-docs group: bills, statements, invoices, payment requests (docs/03 "Vocabulary"). A WP adds to its own group and to docs/03 in the same commit. */
export const billingDocsPermissions = [
  'bill:read',
  'bill:issue',
  'bill:confirm',
  'statement:issue',
  'invoice:read',
  'invoice:issue',
  'invoice:void',
  'payment_request:create',
  'payment_request:approve',
] as const;

export type BillingDocsPermission = (typeof billingDocsPermissions)[number];
